'use strict';

/** 
* This block is designed to open popup link in same popup. 
* To add this behavior just add DATA-BLOCK-MODIFIERS="Navigate-Inner" to waf-action 
* Links with DATA-CUSTOM-ACTION-TYPE="navigate-always" ('[data-command-behavior='navigate-always"]') will be ignored 
* @see modals.js for navigation logic 
*/
blocks.register('waf-action_Navigate-Inner', function () {
    return {
        link: function link($block) {
            $('a:not([data-command-behavior="navigate-always"])', $block).click(function (event) {
                var href = $(this).attr('href');
                $block.trigger({
                    type: 'navigate-inner',
                    href: href
                });

                event.preventDefault();
            });
        }
    };
});